<div class="gao-user-form-container">
  <form fxFlex="1 1 100%;" #registerForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="selectedUser!==null && selectedUser!==undefined">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">
          <span *ngIf="addOrEditInd === 'A'">Add GAO User</span>
          <span *ngIf="addOrEditInd === 'E'">Edit GAO User</span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px grid">
          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Email</mat-label>
            <input matInput id="email" name="email" [(ngModel)]="selectedUser.email" #email="ngModel" required email [disabled]="addOrEditInd === 'E'" />
            <mat-error *ngIf="email.invalid && email.touched">Please enter email address</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Title</mat-label>
            <input matInput id="title" name="title" [(ngModel)]="selectedUser.title" />
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Prefix</mat-label>
            <input matInput id="prefix" name="prefix" [(ngModel)]="selectedUser.prefix" />
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>First Name</mat-label>
            <input matInput id="firstName" name="firstName" [(ngModel)]="selectedUser.first_Name" #firstName="ngModel" required />
            <mat-error *ngIf="firstName.invalid && firstName.touched">First Name is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Middle Initial</mat-label>
              <input matInput id="middleInitial" name="middleInitial" [(ngModel)]="selectedUser.middle_initial" maxlength="1" />
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Last Name</mat-label>
              <input matInput id="lastName" name="lastName" [(ngModel)]="selectedUser.last_Name" #lastName="ngModel" required />
              <mat-error *ngIf="lastName.invalid && lastName.touched">Last Name is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Suffix</mat-label>
              <input matInput id="suffix" name="suffix" [(ngModel)]="selectedUser.suffix" />
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Phone Number</mat-label>
              <input matInput id="phoneNumber" name="phoneNumber" [(ngModel)]="selectedUser.phone_No" #phoneNumber="ngModel" required />
              <mat-error *ngIf="phoneNumber.invalid && phoneNumber.touched">Phone Number is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Fax Number</mat-label>
              <input matInput id="faxNumber" name="faxNumber" [(ngModel)]="selectedUser.fax_No" />
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Group</mat-label>
              <mat-select id="group" name="group" [(ngModel)]="selectedUser.group_No" #group="ngModel"
                          required placeholder="Please Select a Group">
                <mat-option value="">Please Select a Group</mat-option>
                <mat-option *ngFor="let groupNum of groupNumbers" [value]="groupNum">{{'Group ' + groupNum}}</mat-option>
                <!-- Add your groups here -->
              </mat-select>
              <mat-error *ngIf="group.invalid && group.touched">Group is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>Role</mat-label>
              <mat-select id="role" name="role" (selectionChange)="populateRole()"
                          [(ngModel)]="selectedUser.role_id" #role="ngModel" required placeholder="Select Role">
                <mat-option value="">Please Select a Role</mat-option>
                <mat-option *ngFor="let gaoRole of gaoRoles" [value]="gaoRole.value">{{gaoRole.name}}</mat-option>
                <!-- Add your roles here -->
              </mat-select>
              <mat-error *ngIf="role.invalid && role.touched">Role is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
            <mat-label>GAO ID</mat-label>
              <input matInput id="gaoId" name="gaoId" [(ngModel)]="selectedUser.gao_user_id" #gaoId="ngModel" required />
              <mat-error *ngIf="gaoId.invalid && gaoId.touched">GAO ID is required</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="50%" appearance="outline" floatLabel="always" *ngIf="addOrEditInd === 'A'">
            <mat-label>Confirm GAO ID</mat-label>
            <input matInput id="confirmGaoId" name="confirmGaoId" [(ngModel)]="confirmGaoId" #confirmGaoIdEl="ngModel"
                   (paste)="disablePaste($event)" required />
            <mat-error *ngIf="confirmGaoIdEl.invalid && confirmGaoIdEl.touched">Confirming GAO ID is required</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayoutAlign="center" fxLayoutGap="8px">
        <button mat-raised-button color="primary" type="submit"
                (click)="btnClicked.emit({eventCode: 'S', savedUser: selectedUser})"
                [disabled]="!canSave(registerForm) || saving" class="spinner-black">
          <div *appSpinner="saving"></div>
          Save
        </button>
        <button mat-raised-button
                color="warn" type="button"
                (click)="btnClicked.emit('C')"
        >
          Cancel
        </button>
        <button mat-raised-button
                type="button" color="warn"
                (click)="btnClicked.emit('D')">
          Delete User
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
